import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LogConsole } from './publishers/log-console';
import { LogLocalStorage } from './publishers/log-local-storage';
import { LogPublisher } from './publishers/log-publisher';
import { LogWebApi } from './publishers/log-web-api';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LogPublisherConfig } from './publishers/log-publisher-config';
import { throwError } from 'rxjs';

const PUBLISHERS_FILE = "/assets/data/log-publishers.json";

@Injectable({
  providedIn: 'root'
})
export class LogPublisherService {


  publishers: LogPublisher[] = [];

  constructor(private http: HttpClient) { 
    this.buildPublishers();
  }



  buildPublishers(): void {
    //this.publishers.push(new LogConsole());
    //this.publishers.push(new LogLocalStorage())
    //this.publishers.push(new LogWebApi(this.http))

    let logPub: LogPublisher;
    
    this.getLoggers().subscribe(response => {
        for (let pub of response.filter(p => p.isActive)) {
            switch (pub.loggerName.toLowerCase()) {
                case "console":
                    logPub = new LogConsole();
                    break;
                case "localstorage":
                    logPub = new LogLocalStorage();
                    break;
                case "webapi":
                    logPub = new LogWebApi(this.http);
                    break;
            }
            
            // Set location of logging
            logPub.location = pub.loggerLocation;
            
            // Add publisher to array
            this.publishers.push(logPub);
        }
    });
  }

  getLoggers(): Observable<LogPublisherConfig[]> {
    return this.http.get(PUBLISHERS_FILE).pipe(
      map((response:any) =>{
        return response;
      }), 
    catchError(this.handleErrors));
}

  private handleErrors(error: any):
    Observable<any> {
    let errors: string[] = [];
    let msg: string = "";

    msg = "Status: " + error.status;
    msg += " - Status Text: " + error.statusText;
    
    if (error) {
      msg += " - Exception Message: " + error.exceptionMessage;
    }
    errors.push(msg);
    console.error('An error occurred', errors);
    return throwError(() => errors);
    
  }

}
